import Axios from 'axios'
import env from '../../../utillities/env'

export const getHotCategories = () => {
  return Axios.get(env.PUBLIC_API_UPSTASH + '/get/hot_job_cates', {
    headers: { Authorization: `Bearer ${env.PUBLIC_API_UPSTASH_AUTHEN_TOKEN}` }
  })
}
